module.exports = __webpack_public_path__ + "public/images/wsj@2x.8d91c0561db2de9580330dc3ed4a913c.png";